<template>
    <div>
        <vc-date-picker v-model="selectedDate" mode="date" :attributes='attrs' color="gray">
            <template #day-popover="{ day, dayTitle, attributes }" >
                <div class="text-xs text-gray-300 font-semibold text-center">
                    {{ dayTitle }}
                </div>
                <div
                    v-for="attr in attributes"
                    :key="attr.key"
                    :attribute="attr">
                    <h3>{{ attr.customData.name != null ? attr.customData.name: 'No name D:' }} {{getTime(attr.dates)}}</h3>
                    <div class="pl-3">
                        <span class="score">{{attr.customData.team1_score}}</span><span>{{getTeams(attr.customData.players, 1)}}</span>
                    </div>
                    <div class="text-center">Vs</div>
                    <div class="pl-3">
                        <span class="score">{{attr.customData.team2_score}}</span><span>{{getTeams(attr.customData.players, 2)}}</span>
                    </div>
                </div>
            </template>            
        </vc-date-picker>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
    export default {
        name: "Calendar",
        data() {
            return {
                attrs: [
                // This is a single attribute
                ],
                selectedDate: new Date()
            }
        },
        methods: {
            setGamesToCalendar(){
                this.attrs = []
                let games = this.$store.state.games
                for(let game of games){
                    if(game.state == 3 && game.players.length == 6){
                        let date = new Date(game.date)
                        this.attrs.push({
                            key: game.id,
                            customData: game,
                            dot: {
                                color: 'red',
                                fillMode: 'solid',
                            },
                            popover: {
                                visibility: 'hover',
                            },
                            dates: date,
                        })
                    }
                }
            },
            getTeams(players, teamNumber){
                let team = players.filter(player => player.team == teamNumber)                 
                return `${team[0].name}, ${team[1].name}, ${team[2].name}`
            },
            getTime(day){
                let date = new Date(day[0].start)       
                return `${('0' + date.getHours()).slice(-2)}:${('0' + date.getMinutes()).slice(-2)}`
            },
            clicked(item){
                console.log("CLICK", item)
            }
        },
        computed: {
            ...mapGetters(['numberOfGames']),
        },
        watch: {
            numberOfGames(){
                this.setGamesToCalendar()
            }
        },
        mounted(){
            if(this.numberOfGames > 0){
                setTimeout(this.setGamesToCalendar, 100)                
            }
        }
    }
</script>

<style lang="scss" scoped>
.score{
    font-size: 16px;
    margin-right: 6px;
}

</style>